/**
 * Sticky bottom product CTA: show when main add-to-cart scrolls out of view;
 * trigger button mirrors main submit + loading; price/image sync on variant change.
 */
(function () {
  function stripTrailingDoubleZero(text) {
    if (!text) return '';
    return text.replace(/(\.\d{2})(?=\D*$)/, (m) => (m === '.00' ? '' : m));
  }

  function getDisplayedPrice(priceRoot) {
    if (!priceRoot) return '';
    const sale = priceRoot.querySelector('.price-item--sale.price-item--last');
    if (sale) {
      const saleWrap = priceRoot.querySelector('.price__sale');
      if (saleWrap && window.getComputedStyle(saleWrap).display !== 'none') {
        return stripTrailingDoubleZero(sale.textContent.trim());
      }
    }
    const reg = priceRoot.querySelector('.price__regular .price-item--regular');
    if (reg) return stripTrailingDoubleZero(reg.textContent.trim());
    const any = priceRoot.querySelector('.price-item');
    return any ? stripTrailingDoubleZero(any.textContent.trim()) : '';
  }

  function initSticky(root) {
    if (root.dataset.stickyCtaInit === '1') return;
    root.dataset.stickyCtaInit = '1';

    const sectionId = root.dataset.sectionId;
    const mainBtn = document.querySelector(root.dataset.submitSelector);
    if (!mainBtn) return;

    const stickyBtn = root.querySelector('[data-sticky-cta-trigger]');
    const priceEl = root.querySelector('[data-sticky-cta-price]');
    const imgEl = root.querySelector('[data-sticky-cta-image]');
    const stickyLabel = root.querySelector('[data-sticky-cta-btn-label]');
    const priceBlockSelector = root.dataset.priceSelector || `#price-${sectionId}`;
    const fallbackImg = root.dataset.fallbackImage;

    function setVisible(show) {
      if (show) {
        root.classList.add('is-visible');
        root.setAttribute('aria-hidden', 'false');
      } else {
        root.classList.remove('is-visible');
        root.setAttribute('aria-hidden', 'true');
      }
    }

    function updateVisibility(entry) {
      if (!entry) return;
      if (entry.isIntersecting) {
        setVisible(false);
        return;
      }
      const top = entry.boundingClientRect.top;
      if (top < 0) {
        setVisible(true);
      } else if (top > window.innerHeight) {
        setVisible(false);
      }
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach(updateVisibility);
    }, { root: null, threshold: 0, rootMargin: '0px' });

    io.observe(mainBtn);

    stickyBtn.addEventListener('click', () => {
      if (mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true') return;
      mainBtn.click();
    });

    function syncLoadingFromMain() {
      const loading = mainBtn.classList.contains('loading');
      stickyBtn.classList.toggle('loading', loading);
      const sp = stickyBtn.querySelector('.loading__spinner');
      if (sp) sp.classList.toggle('hidden', !loading);
      stickyBtn.toggleAttribute('disabled', mainBtn.disabled);
    }

    function syncLabelFromMain() {
      const span = mainBtn.querySelector(':scope > span');
      if (span && stickyLabel && !span.classList.contains('sold-out-message')) {
        stickyLabel.textContent = span.textContent;
      }
    }

    const mo = new MutationObserver(() => {
      syncLoadingFromMain();
    });
    mo.observe(mainBtn, { attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled'] });

    syncLoadingFromMain();
    syncLabelFromMain();

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const d = event && event.data;
        if (!d || String(d.sectionId) !== String(sectionId)) return;

        requestAnimationFrame(() => {
          const pr = document.querySelector(priceBlockSelector);
          if (priceEl && pr) priceEl.textContent = getDisplayedPrice(pr);
          syncLoadingFromMain();
          syncLabelFromMain();
        });

        const v = d.variant;
        if (imgEl && v && v.featured_image && v.featured_image.src) {
          let src = v.featured_image.src;
          if (src.startsWith('//')) src = `https:${src}`;
          try {
            const u = new URL(src, window.location.origin);
            u.searchParams.set('width', '160');
            imgEl.src = u.toString();
          } catch (e) {
            imgEl.src = src;
          }
        } else if (imgEl && fallbackImg) {
          imgEl.src = fallbackImg;
        }
      });
    }
  }

  function initAll(container) {
    (container || document).querySelectorAll('[data-sticky-cta]').forEach(initSticky);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());

  document.addEventListener('shopify:section:load', (e) => {
    initAll(e.target);
  });
})();
